/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrNumberFormatSpecifier } from './igr-number-format-specifier';
import { NumberFormatSpecifier } from './NumberFormatSpecifier';
import { TypeRegistrar } from './type';
var IgrNumberFormatSpecifierModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrNumberFormatSpecifierModule() {
    }
    IgrNumberFormatSpecifierModule.register = function () {
        TypeRegistrar.registerCons("IgrNumberFormatSpecifier", IgrNumberFormatSpecifier);
        TypeRegistrar.register("NumberFormatSpecifier", NumberFormatSpecifier.$type);
    };
    return IgrNumberFormatSpecifierModule;
}());
export { IgrNumberFormatSpecifierModule };
//# sourceMappingURL=igr-number-format-specifier-module.js.map
